import React from "react";
import "./educations.css";
import { PiGraduationCapFill } from "react-icons/pi";

const Educations = () => {
  return (
    <section id="educations">
      <h5>Academic Background</h5>
      <h2>Education</h2>

      <div className="container educations__container">
        <div className="education__cards">
          {/* first-edu */}
          <article className="education__card">
            <div className="education__content">
              <PiGraduationCapFill className="education__icon"/>
              <span className="education__year">2024 - Present</span>
            </div>
            
            <h3>Master in AI & Computer Engineering</h3>
            <h4>Faculty of Science and Technology Gueliz</h4>
            <p>
              Specializing in machine learning, data analysis, and computer
              vision. Coursework includes advanced algorithms and big data
              processing.
            </p>
          </article>

          {/* seconde-edu */}
          <article className="education__card">
            <div className="education__content">
              <PiGraduationCapFill className="education__icon"/>
              <span className="education__year">2023 - 2024</span>
            </div>
            
            <h3>Bachelor's in Distributed Computer Systems</h3>
            <h4>Faculty of Science and Technology Gueliz</h4>
            <p>
              Gained expertise in distributed architectures, database systems,
              and network programming.
            </p>
          </article>

          {/* third-edu */}
          <article className="education__card">
            <div className="education__content">
              <PiGraduationCapFill className="education__icon"/>
              <span className="education__year">
              2021 - 2023
            </span>
            </div>
            
            <h3>University Diploma in Science & Technology</h3>
            <h4>Faculty of Science and Technology Gueliz</h4>
            <p>
              Fundamental training in programming, mathematics, and computer
              science principles.
            </p>
          </article>

          {/* fourth-edu */}
          <article className="education__card">
            <div className="education__content">
              <PiGraduationCapFill className="education__icon"/>
              <span className="education__year">2020 - 2021</span>
            </div>
            
            <h3>Baccalaureate in Mathematical Sciences</h3>
            <h4>Mohamed 6 High School Taliouine</h4>
            <p>
              Developed strong analytical and problem-solving skills through
              advanced mathematics coursework.
            </p>
          </article>
        </div>
      </div>
    </section>
  );
};

export default Educations;
